import api from './axios';

// Get all messages
export const getAllMessages = async (params = {}) => {
  const response = await api.get('/messages', { params });
  return response.data;
};

// Get single message
export const getMessageById = async (id) => {
  const response = await api.get(`/messages/${id}`);
  return response.data;
};

// Send message (public)
export const sendMessage = async (data) => {
  const response = await api.post('/messages', data);
  return response.data;
};

// Reply to message
export const replyToMessage = async (id, response) => {
  const res = await api.patch(`/messages/${id}/reply`, { response });
  return res.data;
};

// Update message status
export const updateMessageStatus = async (id, status) => {
  const response = await api.patch(`/messages/${id}/status`, { status });
  return response.data;
};

// Toggle star
export const toggleStar = async (id) => {
  const response = await api.patch(`/messages/${id}/star`);
  return response.data;
};

// Delete message
export const deleteMessage = async (id) => {
  const response = await api.delete(`/messages/${id}`);
  return response.data;
};

const messageService = {
  getAllMessages,
  getMessageById,
  sendMessage,
  replyToMessage,
  updateMessageStatus,
  toggleStar,
  deleteMessage,
};

export default messageService;
